/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Clear_StateInputs */



/**
* | output |
* | --- |
* | "Clear the invoice-state filter" |
*
* @param {Partner_Billing_Board_Clear_StateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_clear_state = /** @type {((inputs?: Partner_Billing_Board_Clear_StateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Clear_StateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Rechnungsstatus-Filter zurücksetzen")
	return /** @type {LocalizedString} */ ("Clear the invoice-state filter")
});